/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from "react";
import {
  Col,
  Modal,
  Nav,
  Row,
  Tab,
  Image,
  Form,
  Button,
  InputGroup,
} from "react-bootstrap";
import icTitle from "../../../assets/images/ic-edit-modal.svg";
import DeleteBox1 from "../../../assets/images/ic-deletebox.svg";
import CircleAdd from "../../../assets/images/add-circle-line.svg";
import Add from "../../../assets/images/ic-add.svg";
import Add2 from "../../../assets/images/ic-add3.svg";
import Delete from "../../../assets/images/ic-deletebox.svg";
import DeleteBox from "../../../assets/images/ic-deletebox2.svg";
import ENGModalBody from "../../../components/modal/ENGModalBody";
import ENGModalFooter from "../../../components/modal/ENGModalFooter";
import ENGModalHeader from "../../../components/modal/ENGModalHeader";
import "bootstrap/dist/css/bootstrap.min.css";
import "../Help.css";
import Edit from "../../../assets/images/ic-edit.svg";
import HelpSubHeader from "./HelpSubheader";
import TableList from "../modals/table/EditEthicsCounsellorsListTable";
import {
  CounsellorAttributes,
  CounsellorModel,
  GetCounsellors,
} from "../../../features/helpandassistance/counsellorSlice";
import { useAppSelector, useAppDispatch } from "../../../app/hooks";
import { isAdmin, isPermited } from "../../../features/localStorage";
import { transform } from "typescript";
import swal from "sweetalert";
import { GetdeleteethicsCounsellorDetails } from "../../../features/helpandassistance/deleteethicsCounsellorDetailsSlice";
import { GetdeleteethicsCounsellor } from "../../../features/helpandassistance/deleteethicsCounsellorSlice";
import SearchBar from "../../../components/searchbar/SearchBar";
import { formatDate } from "../../../constant/DateFormat";
import { GetinsertCounsellorsList } from "../../../features/helpandassistance/insertCounsellorslistSlice";
import FileUpload from "../../../components/textField/excelUpload";
import Search from "../../../assets/images/search-line.svg";
import { useForm } from "react-hook-form";
// Messages
const required = "This field is required";
const pattern = "Please insert valid input";

// Error Component
const errorMessage = (error: any) => {
  return <div className="invalid-feedback">{error}</div>;
};
interface CounsellorProps {
  counsellor: any;
  label: string;
  isForEdit?: Boolean;
  isListShow: any;
}
type newCompanyGroupList = {
  groupName: string;
  createdBy: string;
  companyId: number;
  ethicsCounsellorDetails: any;
  saveButton: any;
};
const EthicsCounsellorEditModal: React.FC<CounsellorProps> = ({
  counsellor,
  label,
  isForEdit,
  isListShow,
}: CounsellorProps) => {
  const dispatch = useAppDispatch();
  const [modalShow, setModalShow] = useState(false);
  const [toggleDelete, setToggleDelete] = useState(false);
  const [groupDetailsId, setGroupId] = useState();
  const handleClose = () => setModalShow(false);
  const handleShow = () => setModalShow(true);
  const [recordRow, setRecordRow] = useState(false);
  const [saveButton, setSaveButton] = useState(false);
  const [companyGroupList, setCompanyGroupList] = useState([]);
  const [name, setName] = useState("");
  const [file, setFile] = useState("");
  const userDetails = localStorage.getItem("userDetails");
  const userDetailsList: any = userDetails;
  const userDetailsJson = JSON.parse(userDetailsList);
  const [searchData, setsearchData] = useState("");
  const [tabid, setTabId] = useState();

  var searchParams = {
    companyId: 0,
    keyword: searchData,
  };
  const checkDeleteGroupDetailsId = async (id: any) => {
    //await setGroupId(id);
  };

  const refreshList = async () => {
    await dispatch(GetCounsellors(searchParams));
  };
  const addTabList = () => {
    const createSaveButton = (
      <Col className="px-0">
        {" "}
        <Button type="submit" style={styles.button}>
          {" "}
          Save
        </Button>
      </Col>
    );
    let newCompanyList: newCompanyGroupList = {
      groupName: "New List",
      createdBy: "",
      companyId: 5,
      ethicsCounsellorDetails: [],
      saveButton: createSaveButton,
    };

    let prevCompanuList: any = [...counsellor];
    prevCompanuList.push(newCompanyList);
    setCompanyGroupList(prevCompanuList);
    setSaveButton(true);
    //console.log(companyGroupList, "companyGroupList");
  };
  const { register, handleSubmit, errors } = useForm();
  const onSubmit = async (event: any) => {
    // e.preventDefault();
    var data = {
      groupName: name,
      companyId: userDetailsJson.companyId,
    };
    await dispatch(GetinsertCounsellorsList(data));
    await dispatch(GetCounsellors(searchParams));
    window.location.reload();
    setSaveButton(false);
    // window.location.reload()
  };
  const [checkListShow, setCheckListShow] = useState(isListShow);
  useEffect(() => {
    //setTabId(tabid)
    setCompanyGroupList(counsellor);
    if (file !== null || file !== undefined || file !== "") {
      GetCounsellors(searchParams);
    }
    //alert(groupDetailsId)
  }, [counsellor]);
  //console.log(companyGroupList, counsellor,"counsellor11")
  const searchItems = async (searchValue: any, obj: any) => {
    var searchParams = {
      companyId: obj.id,
      keyword: searchData,
    };

    await setsearchData(searchValue);
    //console.log(searchParams, "searchParamssearchParams")
    await dispatch(GetCounsellors(searchParams));
  };
  return (
    <>
      <a
        onClick={handleShow}
        style={
          isForEdit
            ? {
                backgroundColor: "#fff",
                color: "#e31837",
                fontFamily: "Saira",
                fontWeight: 600,
                fontSize: "12px",
                lineHeight: "2",
                textTransform: "uppercase",
              }
            : {
                backgroundColor: "#fff",
                color: "#db233a",
                fontFamily: "Saira",
                fontWeight: "normal",
                fontSize: "16px",
              }
        }
      >
        {isForEdit ? (
          <>
            <Image src={Edit} /> {label}{" "}
          </>
        ) : (
          <> {label} </>
        )}
      </a>

      <Modal
        show={modalShow}
        onHide={handleClose}
        backdrop="static"
        size="xl"
        keyboard={false}
      >
        <ENGModalHeader icon={icTitle} title={label} />
        <ENGModalBody
          contents={
            <>
              <Tab.Container defaultActiveKey={0}>
                <Row style={styles.divWhite} className="mx-auto pb-0">
                  <Col sm={10} className="px-0">
                    <Nav>
                      {companyGroupList?.map((obj: any, index: any) => {
                        return (
                          <Nav.Item style={styles.tabHeading} key={index}>
                            <Nav.Link className="tabs1" eventKey={index}>
                              {obj?.groupName}
                            </Nav.Link>
                          </Nav.Item>
                        );
                      })}
                    </Nav>
                  </Col>

                  {isPermited(9, 2) && (
                    <Col sm={2}>
                      <span style={styles.adcompany}>
                        <a
                          className="float-end"
                          style={styles.link}
                          onClick={addTabList}
                        >
                          {" "}
                          <Image src={Add} onClick={addTabList} /> ADD COMPANY
                        </a>
                      </span>
                    </Col>
                  )}
                </Row>

                <div style={styles.line}></div>

                <Row style={styles.divWhite} className="mx-auto">
                  <Col sm={12} className="px-0">
                    <Tab.Content>
                      {companyGroupList?.map((obj: any, index: any) => {
                        return (
                          <Tab.Pane eventKey={index} key={index}>
                            {isPermited(9, 2) ? (
                              <form onSubmit={handleSubmit(onSubmit)}>
                                <Row
                                  style={styles.divWhite}
                                  className="mx-auto pb-0 p-0"
                                >
                                  <Col sm={2} className="ps-0">
                                    <div className="floating-label-group">
                                      <input
                                        type="text"
                                        name="name"
                                        className="textstyle"
                                        ref={register({
                                          required: true,
                                          pattern: /^[a-zA-Z\s]*$/g,
                                        })}
                                        onChange={(
                                          ev: React.ChangeEvent<HTMLInputElement>
                                        ): void => setName(ev.target.value)}
                                        // defaultValue={obj.groupName}
                                      />
                                      <label className="floating-label">
                                        Name{" "}
                                        <span style={styles.star}> * </span>
                                      </label>
                                      {errors.designation &&
                                        errors.name.type === "required" &&
                                        errorMessage(required)}
                                      {errors.designation &&
                                        errors.name.type === "pattern" &&
                                        errorMessage(pattern)}
                                    </div>
                                  </Col>
                                  {saveButton !== true ? (
                                    <>
                                      <Col sm={3} className="mb-3">
                                        <FileUpload
                                          setFile={setFile}
                                          title="File"
                                          fileValue=""
                                          groupId={obj.id}
                                          apiUrl="ethicsCounsellor"
                                          refreshList={refreshList}
                                        />
                                      </Col>

                                      <Col className="px-0">
                                        <div className="px-1">
                                          <span style={styles.heading1}>
                                            Last Modified By
                                          </span>
                                          <br />
                                          <span style={styles.data}>Admin</span>
                                        </div>
                                      </Col>
                                      <Col className="px-0">
                                        <div className="px-1">
                                          <span style={styles.heading1}>
                                            Modified on
                                          </span>
                                          <br />
                                          <span style={styles.data}>
                                            {formatDate("1-1-2022")}
                                          </span>
                                        </div>
                                      </Col>
                                    </>
                                  ) : null}

                                  {obj.saveButton}
                                  <Col
                                    sm={4}
                                    xs={12}
                                    className="ms-auto pe-0 ps-1"
                                  >
                                    <InputGroup
                                      id="searchbar"
                                      style={{ border: "solid 1px #e4e4e4" }}
                                    >
                                      <Image
                                        style={styles.image1}
                                        className="d-inline border-0 my-auto mx-2"
                                        src={Search}
                                        fluid
                                      />
                                      <Form.Control
                                        onChange={(e) =>
                                          searchItems(e.target.value, obj)
                                        }
                                        name={searchData}
                                        className="border-0 shadow-none ps-0"
                                        style={styles.text1}
                                        type="text"
                                        placeholder="Search"
                                      />
                                    </InputGroup>
                                  </Col>
                                </Row>
                              </form>
                            ) : (
                              <Row style={styles.divWhite}>
                                <Col sm={5} xs={12} className="ms-auto px-0">
                                  {saveButton !== true ? <SearchBar /> : null}
                                  <br />
                                </Col>
                              </Row>
                            )}
                            {/* {isAdmin() &&
                <Row style={styles.divWhite} className="mx-auto">
                   {saveButton!==true?<>
                  <Col sm={6}>
                    <span style={styles.deletecompany}>
                    <a style={styles.link} onClick={() => onDeleteGroup(obj.id)}><Image src={Delete}/> DELETE COMPANY</a>
                    </span>
                  </Col>
                  <Col sm={1} className="ms-auto pe-0 mb-3" onClick={() => setToggleDelete(!toggleDelete)}>
                  <Image src={Add2} onClick={onAddRecord}/>
                  {groupDetailsId===null?
                          <Image src={DeleteBox} onClick={onDeleteGroupDetails} className="float-end logo-img" alt="Logo"/>:
                          <Image src={DeleteBox1} onClick={onDeleteGroupDetails} className="float-end logo-img" alt="Logo"/>
                            }
                        </Col>
                        </>:null}
                </Row>
                } */}

                            {saveButton !== true ? (
                              <TableList
                                tData={obj?.ethicsCounsellorDetails}
                                checkDeleteGroupDetailsId={
                                  checkDeleteGroupDetailsId
                                }
                                id={obj.id}
                                checkListShow={checkListShow}
                                searchData={searchData}
                                setGroupId={setGroupId}
                              />
                            ) : // checkDeleteGroupDetailsId={checkDeleteGroupDetailsId} recordRow={recordRow} id={obj.id}
                            null}
                          </Tab.Pane>
                        );
                      })}
                    </Tab.Content>
                  </Col>
                </Row>
              </Tab.Container>
            </>
          }
        />
        {saveButton !== true ? (
          <ENGModalFooter
            closeMethod={handleClose}
            type="submit"
            title="Done"
          />
        ) : null}
      </Modal>
    </>
  );
};

const styles: any = {
  divWhite: {
    backgroundColor: "#fffff",
    padding: "24px",
  },
  tabHeading: {
    fontFamily: "Saira",
    fontSize: "12px",
    fontWeight: "400",
    color: "#6d6e71",
  },
  star: { color: "#e31837" },
  link: {
    fontFamily: "Saira",
    fontSize: "12px",
    fontWeight: "600",
    color: "#e31837",
    lineHeight: "2",
    textTransform: "uppercase",
    textDecoration: "none",
  },
  line: {
    height: "1px",
    margin: "0px",
    backgroundColor: "#f4f4f4",
  },
  adcompany: {
    color: "#e31837",
    fontSize: "12px",
    float: "right",
  },
  deletecompany: {
    fontSize: "12px",
    color: "#e31837",
    float: "left",
  },
  button: {
    padding: "15px 40px",
    fontFamily: "Saira",
    fontSize: "12px",
    fontWeight: 400,
    fontStretch: "normal",
    fontStyle: "normal",
    borderRadius: "0",
    backgroundColor: "#e31837",
    letterSpacing: "normal",
    border: "0px",
  },
  heading1: {
    fontFamily: "Saira",
    fontSize: "12px",
    fontWeight: "500",
    color: "#6d6e71",
  },
  data: {
    fontFamily: "Saira",
    fontSize: "16px",
    fontWeight: "500",
    color: "black",
  },
};

export default EthicsCounsellorEditModal;
